export var TreatmentUnitStatus;
(function (TreatmentUnitStatus) {
    TreatmentUnitStatus["PLANNED"] = "planned";
    TreatmentUnitStatus["SCHEDULED"] = "scheduled";
    TreatmentUnitStatus["DELIVERED"] = "delivered";
    TreatmentUnitStatus["CANCELLED"] = "cancelled";
    TreatmentUnitStatus["FORFEITED"] = "forfeited";
})(TreatmentUnitStatus || (TreatmentUnitStatus = {}));
//# sourceMappingURL=treatment-unit-status.enum.js.map